import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
  InputSignal,
  effect,
  Renderer2,
  ElementRef,
  computed,
  Signal,
  RendererStyleFlags2,
  inject,
} from '@angular/core';
import { findSubjectIcon, LyceoSubjectIcon } from '@lyceo/shared/util';

import { SubjectIconShape } from '@lyceo/shared/util-models';

@Component({
  selector: 'lyceo-subject-icon',
  imports: [],
  templateUrl: './subject-icon.component.html',
  styleUrls: ['./subject-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    'class': 'lyceo-subject-icon',
    '[class.shape-none]': 'none',
    '[class.shape-round]': 'round',
  },
})
export class SubjectIconComponent {
  private readonly renderer: Renderer2 = inject(Renderer2);
  private readonly elementRef: ElementRef = inject(ElementRef);

  public readonly subjectName: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly shape: InputSignal<SubjectIconShape> =
    input<SubjectIconShape>(SubjectIconShape.NONE);

  protected readonly icon: Signal<LyceoSubjectIcon> = computed(() =>
    findSubjectIcon(this.subjectName()),
  );

  constructor() {
    effect(() => {
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        '--trix-subject-icon-background-color',
        `var(--trix-${this.icon().cssVarDark})`,
        RendererStyleFlags2.DashCase,
      );
    });
  }

  public get none(): boolean {
    return this.shape() === SubjectIconShape.NONE;
  }

  public get round(): boolean {
    return this.shape() === SubjectIconShape.ROUND;
  }
}
